<template lang="html">
  <div id="agents-page">

    <section class="placed-backg header-banners-section-s1" v-bind:style="{ backgroundImage: 'url(public/images/pages/agents/banner-1.jpg)' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="box w-55-p text-left">
              <h1>AGENTES TRAVELOVERS AUTORIZADOS</h1>

              <p class="p-lg">
                Nuestros travelovers son agentes de viajes que te ayudarán a cumplir el viaje de tus sueños.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="agents-section">
      <div class="placed-backg flex-center-xy box-banner">
        <div class="inside">
          <p>
            <img class="vive" src="public/images/pages/agents/vive.png">
          </p>
          <h5>MÁS DE 100 EXPERTOS EN VIAJES<br />NACIONALES E INTERNACIONALES</h5>
        </div>
      </div>

      <div class="container box-agents">
        <div class="row">
          <div class="col-12 col-title">
            <p class="p-stars">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </p>
            <h2 class="title-s1">ASESORES VIAJARE</h2>
            <h5 class="sub">Busca la página de tu asesor aqui:</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-xl-4 col-agents" v-for="(a, aInx) in agents" :key="aInx">
            <div class="box-agent">
              <div class="image">
                <img class="placed-backg" src="public/images/shared/empty.png" v-bind:style="{ backgroundImage: 'url('+a.imageUrl+')' }">
              </div>

              <div class="description">
                <h5 class="name">{{ a.name }}</h5>
                <h6 class="location ">{{ a.whatsapp }}</h6>

                <p>
                  <a class="btn btn-s1 bg-c-primary" @click="openModal(aInx)">CONTACTAR</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal info de agente -->
    <b-modal modal-class="modal-agent-s1" ref="modal-agent" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-lg-7 col-info">
          <h6 class="t-1">TRAVELOVER</h6>
          <h4 class="name">{{ modal.name }}</h4>
          <h5 class="location" v-if="modal.phowhatsappne">Tel. {{ modal.phowhatsappne }}</h5>

          <div class="box-networks">
            <!-- <a class="t-150 btn-network" v-if="modal.whatsapp" :href="'tel:'+modal.whatsapp"><i class="far fa-phone"></i></a> -->
            <a class="t-150 btn-network" v-if="modal.whatsapp" :href="'https://wa.me/'+removeSpaces(modal.whatsapp)"><i class="fa-brands fa-whatsapp"></i></a>
            <a class="t-150 btn-network" v-if="modal.email" :href="'mailto:'+modal.email"><i class="far fa-envelope"></i></a>
            <a class="t-150 btn-network" v-if="modal.facebook" target="_blank" :href="modal.facebook"><i class="fab fa-facebook-f"></i></a>
          </div>

          <div class="box-description">
            <!-- <p>
              ¡Hola! ¿Listo para que preparemos tu viaje? ¡Perfecto! Dime cómo puedo ayudarte. Vamos resolviendo tus dudas y viendo algunas opciones para que tú decidas cómo quieres agendar ese viaje que tienes en mente. Tengo más de 7 años de experiencia asesorando a las personas que como tú, quieren vivir la increíble experiencia que es viajar a través de VIAJARE.
            </p> -->
            <h5 class="f-w-600">Agentes travelovers autorizados</h5>
            <p v-html="modal.description"></p>
          </div>

          <div class="box-buttons">
            <a class="btn btn-s1 bg-c-primary" :href="'tel:'+modal.phone" v-if="modal.phone">CONTACTAR</a>
            <a class="btn btn-s1 bg-c-primary" :href="'mailto:'+modal.email" v-else>CONTACTAR</a>
          </div>

          <p class="mt-4 pt-2 text-center">
           <a class="link-rate" @click="$refs['modal-rate'].show()"><i class="fas fa-stars"></i> Calificar Agente</a>
          </p>
        </div>

        <div class="col-lg-5 placed-backg col-image" v-bind:style="{ backgroundImage: 'url('+modal.imageUrl+')' }">
          <img src="public/images/pages/agents/empty.png">

          <div class="box-stars">
            <b-form-rating inline value="5" disabled></b-form-rating>
            <span class="num">5/5</span>

            <span class="btn-comments" @click="$refs['modal-comments'].show();"><i class="fas fa-comments"></i></span>
          </div>
        </div>
      </div>
    </b-modal>
    <!--  -->

    <!-- Modal calificar -->
    <b-modal modal-class="modal-agent-s1" ref="modal-rate" size="" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <b-form class="col-lg-12 text-center col-info" @submit.prevent="onSubmitRate">
          <div class="box-rate-form">
            <h6 class="t-1">CALIFICAR AGENTE</h6>

            <div class="b-photo">
              <div class="placed-backg photo" v-bind:style="{ backgroundImage:  'url('+modal.imageUrl+')' }"></div>
            </div>

            <h4 class="mt-1 name">{{modal.name}}</h4>

            <p class="mt-3 txt-gray">
              Por favor califica a nuestro agente.
            </p>

            <div class="text-center">
              <div class="b-stars">
                <b-form-rating required inline v-model="forRating.stars"></b-form-rating>
              </div>
            </div>

            <b-form-group class="mt-4 custom-form-group-s1">
              <b-form-input
                v-model="forRating.name"
                placeholder="Nombre"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="mt-4 custom-form-group-s1">
              <b-form-textarea
                v-model="forRating.comments"
                placeholder="Comentario"
                rows="5"
                max-rows="5"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="mt-3">
              <b-button type="submit" class="w-100 btn-s2 outline-cprimary btn-sm">Calificar</b-button>
            </p>
          </div>
        </b-form>
      </div>
    </b-modal>
    <!--  -->

    <!-- Modal comentarios -->
    <b-modal modal-class="modal-agent-s1" ref="modal-comments" size="" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-lg-12 text-center col-info">
          <div class="box-rate-form">
            <h6 class="t-1">AGENTE</h6>

            <div class="b-photo">
              <div class="placed-backg photo" v-bind:style="{ backgroundImage: 'url('+modal.imageUrl+')' }"></div>
            </div>

            <h4 class="mt-1 name">{{modal.name}}</h4>

            <div class="text-center">
              <div class="b-stars">
                <b-form-rating required inline v-model="starsExample" readonly></b-form-rating>
              </div>
            </div>

            <div class="box-comments">
              <h5 class="box-title">COMENTARIOS</h5>

              <div class="box-comment" v-for="(com,indx) in modal.comments" :key="indx">
                <h6 class="co-date">{{com.created}}</h6>
                <h6 class="co-name">{{com.name}}</h6>

                <p>{{com.comments}} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <sweet-modal ref="modalAlert" :icon="modaldata.icon" >
        <p style="text-align: center;">{{ modaldata.msg }}</p>
    </sweet-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      agents: [],

      modal: {
        imageUrl: null,
        imageUrlLg: null,
        name: null,
        phone: null,
        email: null,
        page: null,
        comments:[]
      },

      forRating: {
        stars: null,
        name: null,
        comment: null,
        agents_id:null
      },

      starsExample: 5,
      modaldata:{
        icon:null,
        msg:null
      },
      indxagent:null,
    }
  },

  methods: {
    openModal(indx) {
      this.indxagent = indx;
      this.modal = this.agents[indx];
      this.$refs['modal-agent'].show();
    },

    onSubmitRate(event) {
      this.forRating.agents_id = this.modal.id;
      axios.post(tools.url("/api/agentsComments"),this.forRating).then((response)=>{

					this.getAgents();
          this.modaldata.msg = 'Informacion guardada correctamente';
          this.modaldata.icon = 'success';
          this.$refs.modalAlert.open();

			}).catch((error)=>{
        this.modaldata.msg = 'Error al guardar la informacion';
          this.modaldata.icon = 'error';
          this.$refs.modalAlert.open();
			});


      this.$refs['modal-rate'].hide();
    },

    getAgents(id){
      axios.get(tools.url('/api/agents')).then((response)=>{
        this.agents = response.data;
        if(this.indxagent != null){
            this.modal = this.agents[this.indxagent];
        }
      }).catch((error)=>{

      })
    },

    removeSpaces(val) {
      let str = val.replace(/\s/g, '');
      return str;
    }
  },

  mounted() {
    this.getAgents();
    // this.$refs['modal-agent'].show();
  }
}
</script>
